export interface IBannerCountdown {
  showCountdown?: boolean;
  countdownStartDate?: string;
  countdownEndDate?: string;
}

export interface ITimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

/**
 * What the countdown counts down to (epoch ms) while it should show, else null: hidden before
 * its start, after its end, and when no valid end is set.
 */
export function getCountdownTarget(
  countdown: IBannerCountdown | null | undefined,
  now: number = Date.now(),
): number | null {
  if (!countdown?.showCountdown || !countdown.countdownEndDate) return null;
  const end = new Date(countdown.countdownEndDate).getTime();
  if (!Number.isFinite(end) || end <= now) return null;
  if (countdown.countdownStartDate) {
    const start = new Date(countdown.countdownStartDate).getTime();
    if (Number.isFinite(start) && start > now) return null;
  }
  return end;
}

/** Whole seconds left while the countdown should show, else null. */
export function getCountdownSecondsLeft(
  countdown: IBannerCountdown | null | undefined,
  now: number = Date.now(),
): number | null {
  const target = getCountdownTarget(countdown, now);
  return target === null ? null : Math.max(0, Math.floor((target - now) / 1000));
}

export function splitSeconds(s: number): ITimeLeft {
  return {
    days: Math.floor(s / 86_400),
    hours: Math.floor((s % 86_400) / 3_600),
    minutes: Math.floor((s % 3_600) / 60),
    seconds: s % 60,
  };
}
